var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (this.filesPath)?_c('div',{staticClass:"logo"},[_c('img',{attrs:{"src":this.filesPath,"onerror":"this.style.display = 'none'"}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }